import { colors } from '../variables';
import { hexToRgbaString } from '../../src/color-utils';

const theme = {
  bg: {
    primary: colors.white,
    secondary: colors.semiWhite,
    overlay: 'rgba(0, 34, 56, .2)', // darkBlue1 with 20% opacity
  },
  header: {
    bg: colors.lightBlue1,
    fg: colors.white,
  },
  footer: {
    bg: {
      primary: colors.lightBlue3,
      secondary: colors.lightGray1,
    },
    fg: {
      primary: colors.semiWhite,
    },
  },
  lines: {
    primary: colors.lightGray1,
    secondary: colors.lightGray2,
    tertiary: colors.darkGray1,
    quaternary: colors.darkBlue1,
  },
  text: {
    primary: colors.darkBlue1,
    secondary: colors.darkGray4,
    tertiary: colors.darkGray2,
    quaternary: colors.mediumGray1,

    linkExternal: colors.lightBlue3,
    linkExternalHover: colors.green1,
    linkInternal: colors.darkBlue1,
    linkInternalHover: colors.darkBlue2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.green1,
    negative: colors.red1,
  },
  icons: {
    primary: colors.darkGray4,
    secondary: colors.darkGray2,
    tertiary: colors.mediumGray1,
    quaternary: colors.lightGray2,
    light: colors.mediumGray2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.green1,
  },
  buttons: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
      textHover: colors.white,
    },
    secondary: {
      bg: colors.darkGray2,
      text: colors.white,
      textHover: colors.white,
    },
    tertiary: {
      bg: colors.lightGray1,
      text: colors.darkBlue1,
      textHover: colors.darkBlue1,
      textWithoutBackground: colors.darkGray2,
      textWithoutBackgroundHover: colors.darkBlue1,
    },
    quarternary: {
      bg: colors.darkBlue1,
      text: colors.white,
      textHover: colors.white,
    },
    positive: {
      bg: colors.darkGreen1,
      text: colors.white,
      textHover: colors.white,
    },
    negative: {
      bg: colors.red1,
      text: colors.white,
      textHover: colors.white,
    },
    link: {
      bg: 'transparent',
      text: colors.lightBlue3,
      textHover: colors.green1,
    },
    disabled: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    category: {
      bg: colors.white,
      bgActive: hexToRgbaString(colors.lightBlue3, 0.08),
      text: colors.darkBlue1,
      textHover: colors.lightBlue3,
    },
  },
  pill: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
    },
  },
  inputs: {
    primary: {
      bg: colors.white,
      border: colors.darkGray1,
      borderFocus: colors.lightBlue2,
    },
  },
  dropdowns: {
    primary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: '5px',
      borderColor: {
        active: colors.darkBlue1,
        inactive: colors.darkBlue1,
      },
    },
    secondary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: 0,
      borderColor: {
        active: colors.lightGray1,
        inactive: 'transparent',
      },
    },
  },
};

export type ThemeType = typeof theme & { layout?: string };

export default theme;
